import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerFireDetailListItem = (props) => {
    const { fireSettingsDetail, updateVisualizerSettings, maxFireDetail } = props;
    
    const onFireDetailChange = (value) => {
        previewHistoryBatch.start();
        value = maxFireDetail - Math.sqrt(value);

        updateVisualizerSettings({ 
            fireSettings: { detail: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Detail'
            value={(maxFireDetail - fireSettingsDetail) ** 2}
            displayMultiplier={100 / (maxFireDetail ** 2)}
            min={0}
            max={99}
            step={1}
            onValueChange={onFireDetailChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { detail: fireSettingsDetail } = state.createPreview.present.videoSettings.visualizer.fireSettings;
    const { maxFireDetail } = state.create.maxValues;

    return { 
        fireSettingsDetail,
        maxFireDetail
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerFireDetailListItem);